import { GetterTree } from "vuex";
import { StateInterface } from "src/store";
import { EventsStateInterface } from "./state";
import { EventItem } from "../../models";

const getters: GetterTree<EventsStateInterface, StateInterface> = {
  getBySession(context) {
    return (session_guid: string): EventItem[] => {
      const events = context.sessions[session_guid]?.events ?? [];
      return events.filter(() => true);
    };
  },

  getByGuid(context) {
    return (event_guid: string) => {
      let event = undefined;
      let index = -1;
      for (const session_guid in context.sessions) {
        index =
          context.sessions[session_guid]?.events?.findIndex(
            (x) => x.guid == event_guid
          ) ?? -1;
        if (index > -1) {
          event = context.sessions[session_guid]?.events[index];
          break;
        }
      }
      return event;
    };
  },

  isNew(context) {
    return (event_guid: string): boolean => {
      return !!context.new_events.find(event => event.guid == event_guid);
    };
  }
};

export default getters;
